<template>
  <label
    :class="['flex gap-3', {
      'cursor-pointer': !disabled,
      'flex-row-reverse': isInverted,
      'items-center': isCentered,
    }, _class]"
   
  >
    <div class="flex h-6 shrink-0 items-center">
      <div class="group grid size-4 grid-cols-1">
        <input
          v-model="model"
          :disabled="disabled"
          v-bind="attrs"
          type="checkbox"
          :class="['col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-secondary checked:bg-secondary indeterminate:border-secondary indeterminate:bg-secondary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto', {
            'cursor-pointer': !disabled,
          }]"
        >
        <svg
          class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            class="opacity-0 group-has-checked:opacity-100"
            d="M3 8L6 11L11 3.5"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="opacity-0 group-has-indeterminate:opacity-100"
            d="M3 7H11"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div class="text-base/6 select-none w-full">
      <div class="wrap-anywhere">
        <slot name="label">
          {{ label }}
        </slot>
      </div>

      <div
        v-if="$slots?.subtext"
        class="text-sm/4 text-gray-500"
      >
        <slot name="subtext" />
      </div>
    </div>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  disabled?: boolean
  isInverted?: boolean
  isCentered?: boolean
}>()

const model = defineModel<boolean>()

defineOptions({
  inheritAttrs: false,
})

const { class: _class, ...attrs } = useAttrs()
</script>
